module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 15.9daf2c5f.png";